@if (!sended) {
  <section class="no-auth-page">
    <header>
      <h3>{{ 'auth.resetPwd.title' | translate }}</h3>
      <h4>{{ 'auth.resetPwd.subtitle' | translate }}</h4>
    </header>
    <form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
      <div class="ht-form-item">
        <div class="ht-form-item-title">
          {{ 'auth.resetPwd.email' | translate }}
        </div>
        <div class="ht-form-item-control">
          <ht-input
            [label]="'auth.resetPwd.email' | translate"
            type="email"
            formControlName="email"
            [fullWidth]="true"
          ></ht-input>
        </div>
      </div>
      <div class="ht-form-actions">
        <button
          ht-button-primary
          type="submit"
          size="large"
          [fullWidth]="true"
          [isLoading]="isLoading"
        >
          {{ 'auth.resetPwd.sendEmail' | translate }}
        </button>
        <a
          ht-button-primary
          appearance="minimal"
          [fullWidth]="true"
          routerLink="/sign-in"
        >
          {{ 'auth.resetPwd.backToSignIn' | translate }}
        </a>
      </div>
    </form>
  </section>
} @else {
  <section class="no-auth-page">
    <header>
      <h3>{{ 'auth.resetPwd.checkEmailTitle' | translate }}</h3>
    </header>
    <p>
      {{ 'auth.resetPwd.checkEmailBody' | translate }}
    </p>
    @if (!resended) {
      <p>
        {{ 'auth.resetPwd.spamPrefix' | translate }}
        <a (click)="resendEmail()">
          {{ 'auth.resetPwd.resend' | translate }}
        </a>
        {{ 'auth.resetPwd.emailSuffix' | translate }}
      </p>
    }
    @if (resended) {
      <p>{{ 'auth.resetPwd.resendNotice' | translate }}</p>
    }
    <div class="ht-form">
      <div class="ht-form-actions">
        <a
          ht-button-primary
          appearance="minimal"
          routerLink="/sign-in"
          [fullWidth]="true"
        >
          {{ 'auth.resetPwd.goBackToSignIn' | translate }}
        </a>
      </div>
    </div>
  </section>
}
